// 判断当前页面是否为主页面
var Timer = require('./Timer');
var localstorage_and_userdata = require('./localstorage_and_userdata');

var MainPage = function (_webimActiveKey, onchange) {
    var self = this;
    self.webimActiveKey = _webimActiveKey;
    self._isMainPage = false;
    //监听是否需要把自己设置为非主页面(chrome下，使用document.domain之后，无法监听到storage事件）
    if (navigator.userAgent.indexOf("Chrome") > -1) {
        //使用timer定时查询的方式
        var oldWebimActiveValue = null;
        var isWebimActiveTimer = new Timer({
            onElapsed: function (cb) {
                var nowWebimActiveValue = localstorage_and_userdata.getItem(self.webimActiveKey);
                if (nowWebimActiveValue != oldWebimActiveValue) {
                    if (nowWebimActiveValue == self._webimActiveValue) {
                        self._isMainPage = true;
                    } else {
                        self._isMainPage = false;
                    }
                    onchange && onchange(self._isMainPage);
                    oldWebimActiveValue = nowWebimActiveValue;
                }
                cb();
            },
            duration: 200
        });
        isWebimActiveTimer.start();
    } else {
        var handle_storage = function (e) {
            if (e.key == self.webimActiveKey) {
                self._isMainPage = false;
                onchange && onchange(self._isMainPage);
            }
        };
        //使用localstorage的'storage'事件
        if (window.addEventListener) {
            window.addEventListener("storage", handle_storage, false);
        }
        else if (window.attachEvent) {
            window.attachEvent("onstorage", handle_storage);
        }
    }
};
MainPage.prototype.set = function () {
    this._webimActiveValue = new Date().getTime() + '';
    localstorage_and_userdata.setItem(this.webimActiveKey, this._webimActiveValue);
};
MainPage.prototype.get = function () {
    return this._isMainPage;
};

module.exports = MainPage;